import axios, { AxiosInstance, AxiosRequestConfig } from "axios";

class ApiClient {
    private instance: AxiosInstance;

    constructor(baseURL: string, mode: "app" | "shared" = "app") {

        this.instance = axios.create({ baseURL: baseURL });

        this.instance.interceptors.request.use(
            (config) => {
                if (!config.headers?.skipAuth) {
                    const key = mode === "shared" ? "_jwt_fto_shared" : "_jwt_fto";
                    const token = localStorage.getItem(key);
                    if (token) {
                        config.headers["Authorization"] = `Bearer ${token}`;
                    }
                }
                if (config.headers?.skipAuth) {
                    delete config.headers.skipAuth;
                }
                config.headers["Content-Type"] =
                    config.headers["Content-Type"] || "application/json";
                return config;
            },
            (error) => Promise.reject(error)
        );

        // Add response interceptor for 401 handling
        this.instance.interceptors.response.use(
            (response) => response,
            (error) => {
                if (error.response?.status === 401) {
                    const currentPath = window.location.pathname;
                    if (currentPath.startsWith("/app/")) {
                        window.location.href = "/login";
                    }
                }
                return Promise.reject(error);
            }
        );
    }

    async get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
        const response = await this.instance.get(url, config);
        return response.data;
    }

    async post<T = any>(
        url: string,
        data?: any,
        config?: AxiosRequestConfig
    ): Promise<T> {
        const response = await this.instance.post(url, data, config);
        return response.data;
    }

    async patch<T = any>(
        url: string,
        data?: any,
        config?: AxiosRequestConfig
    ): Promise<T> {
        const response = await this.instance.patch(url, data, config);
        return response.data;
    }

    async put<T = any>(
        url: string,
        data?: any,
        config?: AxiosRequestConfig
    ): Promise<T> {
        const response = await this.instance.put(url, data, config);
        return response.data;
    }

    async delete<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
        const response = await this.instance.delete(url, config);
        return response.data;
    }
}

export default ApiClient;